import React from "react";
import "../../styles/automation/inside-sidebar.css";
import HelmetWrapper from "../../HelmetWrapper";

const VoiceoverSystem = () => {
  return (
    <HelmetWrapper title="WTF: Voice Over Management System"></HelmetWrapper>
  );
};

export default VoiceoverSystem;
